import { ChevronDown, ChevronUp } from '@styled-icons/fa-solid';
import { Button } from 'react-bootstrap';

const NumberInput = ({ value, onChange, min = 0, max = 100, step = 1, disabled = false }) => {
  const handleIncrement = () => {
    // If the input is empty, start from min. Otherwise, increment as normal (but don't exceed max).
    if (value === '' || value === null) {
      onChange(min);
    } else if (max === null || value < max) {
      onChange(value + step);
    }
  };

  const handleDecrement = () => {
    if (min === null || value > min) {
      onChange(value - step);
    }
  };

  const handleInputChange = (e) => {
    onChange(Number(e.target.value));
  };

  const onBlur = () => {
    if (value > max) {
      onChange(max);
    }
    if (value < min) {
      onChange(min);
    }

    if (Number.isNaN(Number.parseInt(value))) {
      onChange(0);
    }
  };

  const preventNonNumberInputs = (event) => {
    if (['e', '.', '+', '-'].includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="d-flex pe-1 align-items-stretch">
      <input
        type="number"
        className="number-input"
        value={value}
        onChange={handleInputChange}
        onBlur={onBlur}
        onKeyDown={preventNonNumberInputs}
        disabled={disabled}
      />
      <div className="d-flex flex-column h-100 ms-2">
        <Button
          variant="outline-secondary"
          size="sm"
          className="d-flex h-50"
          onClick={handleIncrement}
          disabled={disabled}
        >
          <ChevronUp width="0.75rem" className="gray-text" />
        </Button>
        <Button
          variant="outline-secondary"
          size="sm"
          className="d-flex h-50"
          onClick={handleDecrement}
          disabled={disabled}
        >
          <ChevronDown width="0.75rem" className="gray-text" />
        </Button>
      </div>
    </div>
  );
};

export default NumberInput;
